const name = 'circle-4';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M36.913 26.829V44.31h3.066v4.475h-3.066V55h-5.634v-6.214H18.02V44.31L30.036 26.83h6.877zm-5.137 4.64h-.497l-2.983 5.8-4.723 7.042h7.706V37.27l.497-5.8z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '4',
};

export default icon;
